import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { HotelBrand } from '@whitbread-eos/api';
import { Accordion } from '@whitbread-eos/atoms';
import { renderSanitizedHtml, useSemanticTypography, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HotelFaq = () => {
  var _useStaticHotelInform = useStaticHotelInformation(),
    brand = _useStaticHotelInform.brand,
    faq = _useStaticHotelInform.faq,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var getTypographyProps = useSemanticTypography();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    faqItemList = _useState2[0],
    setFaqItemList = _useState2[1];
  useEffect(() => {
    var _faq$faqItems;
    var faqItems = [];
    faq === null || faq === void 0 || (_faq$faqItems = faq.faqItems) === null || _faq$faqItems === void 0 || _faq$faqItems.map(faqData => {
      var _faqData$answer;
      var contentText = _jsx(Box, {
        children: renderSanitizedHtml((_faqData$answer = faqData === null || faqData === void 0 ? void 0 : faqData.answer) !== null && _faqData$answer !== void 0 ? _faqData$answer : '')
      });
      faqItems.push({
        title: faqData === null || faqData === void 0 ? void 0 : faqData.question,
        content: contentText
      });
    });
    setFaqItemList(faqItems);
  }, [faq]);
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  var isHubOrPiHotel = [HotelBrand.HUB, HotelBrand.PI, HotelBrand.PID].includes(brand === null || brand === void 0 ? void 0 : brand.toUpperCase());
  if (!isHubOrPiHotel) {
    return null;
  }
  return _jsx(Box, {
    "data-testid": "hdp_faqs",
    children: _jsxs(Box, _objectSpread(_objectSpread({
      maxW: "full"
    }, containerStyles), {}, {
      children: [_jsx(Text, _objectSpread(_objectSpread({
        "data-testid": "hdp-faqs-title",
        as: "h3"
      }, getTypographyProps(headingFaqLegacyTypography, headingFaqSemanticTypography)), {}, {
        children: faq !== null && faq !== void 0 && faq.title ? faq.title : t('hoteldetails.faqs.title')
      })), _jsx(Box, {
        "data-testid": "hdp-faqs-list",
        mt: {
          base: '2',
          sm: '1'
        },
        className: "formatLinks",
        children: _jsx(Accordion, {
          allowMultiple: false,
          accordionItems: faqItemList,
          bgColor: "var(--chakra-colors-lightGrey5)"
        })
      })]
    }))
  });
};
var headingFaqLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: {
    base: 'xl',
    sm: '2xl'
  },
  lineHeight: {
    base: '3',
    sm: '4'
  }
};
var headingFaqSemanticTypography = {
  textStyle: {
    base: 'heading-s',
    md: 'heading-m'
  }
};
var containerStyles = {
  mt: {
    base: 'lg',
    sm: '3xl'
  },
  mb: {
    base: 'lg',
    sm: '2xl'
  }
};